import { AssignInterviewModal } from './AssignInterviewModal';

export default AssignInterviewModal;